import React, { useState } from 'react';
import './Custom-Accordion.scss';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const CustomAccordion = (props) => {
  const {
    header,
    children,
    expanded,
    shadow,
    hasDragSort,
    titleStyles,
    componentNdx,
    toggleExpandedStatus,
    componentExpandStatus,
  } = props;
  const [isExpanded, setExpanded] = useState(expanded);

  const onClickExpand = (e) => {
    setExpanded(!isExpanded);
    const tempExpandedStatus = componentExpandStatus.map((componentStatus, index) => {
      if (index === componentNdx) {
        return !componentStatus;
      } else {
        return componentStatus;
      }
    });
    toggleExpandedStatus(tempExpandedStatus);
  };

  return (
    <div className={` ${shadow ? 'shadow' : ''} d-flex mx-0 px-0 pt-4 custom-accordion`}>
      {hasDragSort && (
        <div className='d-flex align-items-center ps-1'>
          <DragIndicatorIcon fontSize='12' className='drage-icon' />
        </div>
      )}
      <div className='w-100'>
        <div
          className={`col-md-12  d-flex align-items-center mx-0 pe-4 custom-accordion-header`}
          onClick={(e) => onClickExpand(e)}
        >
          <div className={` ${titleStyles ? titleStyles : ''} col-md-10 ps-2`}>{header}</div>
          <div className='col-md-2 d-flex justify-content-end'>
            {' '}
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>
        {isExpanded && (
          <div className='col-md-12 mt-1 mx-0 px-2 custom-accordion-body'>{children}</div>
        )}
      </div>
    </div>
  );
};

export default CustomAccordion;
